import { Chart } from '@frontend/chart/types';

/** Duration values are average completed-timer seconds (same unit as transaction timer duration charts). */
export const EQUIPMENT_TIMERS_DURATION_BY_PRODUCT_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        { name: 'Impact drill', data: [{ label: 'full_period', value: 259200 }] },
        { name: 'Torque wrench', data: [{ label: 'full_period', value: 172800 }] },
        { name: 'Multimeter', data: [{ label: 'full_period', value: 86400 }] },
        { name: 'Laser level', data: [{ label: 'full_period', value: 43200 }] },
        { name: 'Heat gun', data: [{ label: 'full_period', value: 28800 }] },
        { name: 'Cable tester', data: [{ label: 'full_period', value: 14400 }] },
        { name: 'Pipe cutter', data: [{ label: 'full_period', value: 7200 }] },
        { name: 'Inspection camera', data: [{ label: 'full_period', value: 3600 }] }
    ]
};
